import React from 'react';
import {Form, Textarea, List} from 'components';
import {useNamedSelector} from 'helpers';

export function Spirituality() {
  return (
    <Form {...useNamedSelector('clarity.form', { name: 'spirituality' })}>
      <List tiny-gutter>
        <List.Title>Describe your spiritual practices and beliefs</List.Title>
        <Textarea single name="1" />
        <List.Title>What is missing for you in your spiritual life?</List.Title>
        <Textarea single name="2" />
        <List.Title>How does your spirituality fit in with the rest of your life?</List.Title>
        <Textarea single name="3" />
        <List.Title>How do your spiritual practices enhance your life?</List.Title>
        <Textarea single name="4" />
        <List.Title>What holds you back from engaging with your spiritual self?</List.Title>
        <Textarea single name="5" />
        <List.Title>What does your ideal spiritual life look like?</List.Title>
        <Textarea single name="6" />
        <List.Title>Where do you find support (or resistance) for your spiritual self?</List.Title>
        <Textarea single name="7" />
        <List.Title>How can you elevate and grow your spiritual side?</List.Title>
        <Textarea single name="8" />
      </List>
    </Form>
  );
}
